import { Direction, Alignment, Justification } from '../ui';

const mapObjectToAttributes = (obj: object) => {
    const attributes = Object.keys(obj).map(attr => `${attr}="${obj[attr]}"`);
    return attributes.join(' ');
};

const mapObjectToStyles = (obj) => {
    const styles = Object.keys(obj).map(style => `${style}: ${obj[style]}`);
    return `style="${styles.join('; ')}"`;
};

const build = (template, styles = {}, attrs = {}, classes: string[] = []) =>
    `<div class="${classes.join(' ')}" ${mapObjectToStyles(styles)} ${mapObjectToAttributes(attrs)}>${template}</div>`;

export interface IFlexParam {
    flex?: boolean;
    direction?: Direction;
    alignment?: Alignment;
    justification?: Justification;
    fix?: boolean;
}

export class Wrapper {
    constructor(private _template: string) { }

    private _stylesObj: any;
    private _attrsObj: any;
    private _classes: string[] = [];

    private _flexDefaults: IFlexParam = { flex: true, alignment: 'stretch', justification: 'flex-start', direction: 'column', fix: true };

    public withStyles = (styles) => {
        this._stylesObj = { ...this._stylesObj, ...styles };
        return this;
    }

    public withAttrs = (attrs) => {
        this._attrsObj = { ...this._attrsObj, ...attrs };
        return this;
    }

    public withWidth = (width: string) => {
        this._stylesObj = { ...this._stylesObj, ...{ width } };
        return this;
    }

    public withHeight = (height: string) => {
        this._stylesObj = { ...this._stylesObj, ...{ height } };
        return this;
    }

    public withMaxWidth = (width: string) => {
        this._stylesObj = { ...this._stylesObj, ...{ 'max-width': width } };
        return this;
    }

    public withMaxHeight = (height: string) => {
        this._stylesObj = { ...this._stylesObj, ...{ 'max-height': height } };
        return this;
    }



    public withFlex = (params: IFlexParam = this._flexDefaults) => {
        this._attrsObj = { ...this._attrsObj, ...this._flexDefaults, ...params };
        return this;
    }

    public withClass(className: string) {
        this._classes.push(className);
        return this;
    }

    build() {
        return build(this._template, this._stylesObj, this._attrsObj, this._classes);
    }
}

export const wrapper = (template: string) => new Wrapper(template);

// export const withMaxWidth = (template: string, width: number) => `<div style="max-width: ${width}px">${template}</div>`;
// export const wrapWith700pxDiv = (template: string) => withMaxWidth(template, 700);

// export const withHeight = (template: string, height: number) => `<div style="min-height: ${height}px">${template}</div>`;

// export const centered = (template: string) => `<div flex="true" fix="true"
// alignment="center" justification="center" style="padding: 100px; width:100%; height:100%">${template}</div>`;
